import { CoreIcon } from '../core-icon';
import negativeCircleSVG from '../../assets/icons/negative-circle.svg';
import type { IconProps } from '../core-icon';

export const NegativeCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={negativeCircleSVG} {...props} />;
};
